<app-performance>
    <app-data-grid-comp
        [gridId]="gridId"
        [tableId]="db_tables.ReviewRatings"
        [columns]="columns"
        [filterCategories]="filterCategories"
        [gridData]="gridData"
        [gridDataResult]="gridDataResult"
        [isLoading]="isLoading"
        [pageSize]="pageSize"
        [skip]="skip"
        category="ReviewRatings"
        [rowSelectionSettings]="{
            canSelectRows: true,
            selectableMode: 'multiple',
            selectRowBy: 'id'
        }"
        clickableRows="true"
        [isLoading]="isLoading"
        [clearSelectedItems]="clearSelectedItems"
        searchable="true"
        [sortable]="{
            mode: 'multiple'
        }"
        [sortableColumns]="sortableColumns"
        (emitGridStateChangeEvent)="gridStateChange($event)"
        (emitOpenDialogEvent)="getReviewRating($event)"
        (emitDeleteEvent)="deleteReviewRatings($event)"
    ></app-data-grid-comp>
</app-performance>
